/* AB-EXC-17 · Sugerencias en la bolsa (B; C lo extiende). En la carga solo registra 1 listener: nada de fetch, nada de envolver fetch. */
(() => {
  if (window.abRecs) return;
  window.abRecs = true;
  const live = (msg) => { const r = document.getElementById('CartDrawer-LiveRegionText'); if (r) r.textContent = msg; };
  const page = (sec, dir) => {
    const t = sec.querySelector('[data-ab-recs-track]');
    t.scrollBy({ left: dir * t.clientWidth, behavior: 'smooth' });
  };
  const sync = (t) => {
    const sec = t.closest('[data-ab-recs]'); const i = Math.round(t.scrollLeft / t.clientWidth);
    sec.querySelectorAll('.ab-recs__dots i').forEach((d, k) => d.classList.toggle('on', k === i));
    const p = sec.querySelector('[data-ab-recs-prev]'), n = sec.querySelector('[data-ab-recs-next]');
    if (p) p.disabled = i === 0; if (n) n.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
  };
  // Miniaturas con data-src: se cargan solo con el cajón abierto (o si las sugerencias no están en el cajón)
  const load = (i) => { if (i.dataset.src) { i.src = i.dataset.src; i.removeAttribute('data-src'); } };
  // Slider: solo carga las miniaturas de tarjetas visibles (o la que asoma); el resto al deslizar
  const show = (root) => root.querySelectorAll('[data-ab-recs] img[data-src]').forEach((i) => {
    const t = i.closest('.ab-recs--slider [data-ab-recs-track]');
    if (!t || !window.IntersectionObserver) return load(i);
    if (i.dataset.abObs) return; i.dataset.abObs = '1';
    new IntersectionObserver((es, o) => es.forEach((e) => { if (e.isIntersecting) { load(e.target); o.unobserve(e.target); } }), { root: t, rootMargin: '0px 20% 0px 0px' }).observe(i);
  });
  const cd = document.querySelector('cart-drawer');
  const chk = () => { if (cd.classList.contains('active')) show(cd); };
  if (cd) { chk(); new MutationObserver(chk).observe(cd, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true }); }
  document.querySelectorAll('[data-ab-recs]').forEach((r) => { if (!r.closest('cart-drawer')) show(r.parentElement); });
  document.addEventListener('scroll', (e) => { if (e.target.matches && e.target.matches('[data-ab-recs-track]')) sync(e.target); }, true);
  async function add(btn) {
    const sec = btn.closest('[data-ab-recs]'); const drawer = document.querySelector('cart-drawer');
    const all = sec.querySelectorAll('[data-ab-recs-add]'); const err = btn.parentElement.querySelector('.ab-recs__err');
    all.forEach((b) => (b.disabled = true)); btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); if (err) err.hidden = true;
    try {
      const res = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: +btn.dataset.abRecsAdd, quantity: 1, sections: drawer.getSectionsToRender().map((s) => s.id), sections_url: window.location.pathname }),
      });
      const j = await res.json();
      if (!res.ok || j.status) throw new Error(j.description || j.message || '');
      btn.classList.remove('is-loading'); btn.classList.add('is-added'); btn.textContent = btn.dataset.done || '✓ Agregado'; live(`Agregado: ${btn.dataset.name}`);
      await new Promise((r) => setTimeout(r, 700));
      drawer.renderContents(j);
      if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ab-recs', cartData: j });
    } catch (e) {
      all.forEach((b) => (b.disabled = false)); btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
      btn.textContent = btn.dataset.retry || 'Reintentar'; if (err) { err.textContent = e.message || 'No se pudo agregar. Intenta de nuevo.'; err.hidden = false; }
    }
  }
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-ab-recs-add]'); if (a) { e.preventDefault(); add(a); return; }
    const p = e.target.closest('[data-ab-recs-prev],[data-ab-recs-next]');
    if (p) page(p.closest('[data-ab-recs]'), p.hasAttribute('data-ab-recs-next') ? 1 : -1);
  });
})();
